import { Box, Grid, useTheme } from "@mui/material";
import {
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
	YEAR_SCREEN_SLUG,
} from "../../../common/constants";
import React, { useCallback, useEffect, useState } from "react";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { PrimeDataGrid } from "../../PrimeDataGrid";
import { YearService } from "../../../services/YearService";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";
import { useNavigateToLogout } from "../../../common/Common";

// import { EnhancedDDLBulkAction } from "@websential/ws-react-ui/lib/components/EnhancedDDLBulkAction";
// import { EnhancedDialog } from "@websential/ws-react-ui/lib/components/EnhancedDialog";
// import { ErrorState } from "@websential/ws-react-ui/lib/components/ErrorState/ErrorState";
// import { StatusChip } from "@websential/ws-react-ui/lib/components/StatusChip";















export interface IYearList { }
const YEAR_LIST_QUERY_KEY: any = "years-list";

const useYears = (
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["years-list", params],
		queryFn: (data) => {
			return YearService.getList(params, navigateToLogout);
		},
		refetchOnWindowFocus: false
	});

export const YearList: React.FC<IYearList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const navigateToLogout = useNavigateToLogout();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "role_name",
		order_direction: "asc",
		page: 1,
		size: INITIAL_PAGE_SIZE,
	});

	const { isPending, data } = useYears(queryParams, navigateToLogout); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const dataRolesList: any = data;


	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [yearId, setYearId] = useState<number>(0);

	const onRequestParamsChange = useCallback((requestParams: any) => {

		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onRowEditClicked = useCallback((params: any) => {
		let path = `/tax-year/setup/${params.row.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	// For Delete Row
	const deleteYearField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			deleteYearById(yearId);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setApiAction("delete");
		setYearId(params.row.id);

		// alert(`Delete row with ID: ${params.row.id} has been clicked!`);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteYearById } = useMutation({
		mutationFn: YearService.delYear,
		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});

				return queryClient.invalidateQueries(YEAR_LIST_QUERY_KEY);
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	}
	);

	const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setStatusValue(event.target.value as string);
		setApiAction("updateStatus");
		setDialogOpen(true);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);
		if (selectedItems.length) {
			return (
				<Box sx={{ marginTop: theme.spacing(1) }}>
					{"Bulk Action Drop Down List"}
					{/* <EnhancedDDLBulkAction
            label="Status"
            value={statusValue}
            onChangeHandler={handleChange}
            options={[
              { name: "Active", value: "1" },
              { name: "Inactive", value: "2" },
            ]}
            testId="status-dd"
          /> */}
				</Box>
			);
		}
		return (
			<Box sx={{ marginTop: theme.spacing(1) }}>
				<RouterLinkButton to="/tax-year/setup" text="Add Year" />
			</Box>
		);
	}, []);

	//find the index of object from headerColumns to add link on given column
	// if (accountantList?.headerColumns) {
	//   const linkObjIndex = accountantList.headerColumns.findIndex(
	//     (obj: { field: any; }) => obj.field === accountantList.keyField.field
	//   );
	//   accountantList.headerColumns[linkObjIndex] = {
	//     field: accountantList.headerColumns[linkObjIndex].field,
	//     headerName: accountantList.headerColumns[linkObjIndex].headerName,
	//     flex: 1,
	//     renderCell: (params: any) => {
	//       var urlLink = accountantList.keyField.templateUrl;
	//       var newLink = urlLink.replace("{id}", params.row.id);

	//       return (
	//         <Link to={newLink} className={classes.textLink}>
	//           {params.row.accTitle}
	//         </Link>
	//       );
	//     },
	//   };
	//   const statusObjIndex = accountantList.headerColumns.findIndex(
	//     (obj: { field: string; }) => obj.field === "status"
	//   );
	//   accountantList.headerColumns[statusObjIndex] = {
	//     field: "status",
	//     headerName: "Status",
	//     flex: 1,
	//     width: 50,
	//     headerAlign: "center",
	//     align: "center",
	//     renderCell: (params: any) => (
	//       <Chip label={params.value} />
	//     ),
	//   };
	// }

	// if (isPending) {
	//   return (
	//     <CircularProgress
	//       size={24}
	//       data-testid="circular-progress"
	//       className={classes.loader}
	//     />
	//   );
	// }

	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);

	const expandedLabels = ["Misc.", "Tax Year"];
	const expandedBanckListItem = "List";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (parentLabel === "Tax Year" && item.label === expandedBanckListItem) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: isExpanded,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: YEAR_SCREEN_SLUG,
				companyName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return dataRolesList && dataRolesList.items.length === 0 ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add Year to proceed`}
			content={`You can add taxslip year by directly clicking on add taxslip year button.`}
			testId={"taxslip-year-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add  Year"}
			navigateToAdd={"/tax-year/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ width: "100%" }}>
				{/* <EnhancedDialog
        dialogTitle="Please Confirm"
        key="dialog-box"
        testId="dialog"
        onCloseHandler={onCloseHandler}
        open={openDialog}
        dialogContent={
          <Typography variant="subtitle1">Are you sure?</Typography>
        }
        dialogAction={
          <Grid>
            <Button
              autoFocus
              variant="contained"
              onClick={onCloseHandler}
              color="default"
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              autoFocus
              variant="contained"
              onClick={callAction}
              color="primary"
              className={classes.button}
            >
              ok
            </Button>
          </Grid>
        }
      /> */}
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deleteYearField}
					cancelActionHandler={onCloseHandler}
					testId="year-field-tab-confirmation-dialog"
				/>
				{/* <EnhancedDataGrid
          columns={dataRolesList ? dataRolesList.headerColumns : []}
          rows={dataRolesList?.items}
          selectionEnabled={true}
          autoHeight={true}
          allowSearching={true}
          rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
          selectionToolbar={selectionToolbar}
          onRowEditClicked={onRowEditClicked}
          onRowDeleteClicked={onRowDeleteClicked}
          // initialPage={0}
          initialPageSize={INITIAL_PAGE_SIZE}
          disableColumnMenu={true}
          showRowActionsColumn={true}
          autoPageSize={false} //
          showIndexColumn={true}
          testId="years-list-grid"
          sortingMode="server"
          filterMode="server"
          paginationMode="server"
          onRequestParamsChange={onRequestParamsChange}
          totalRowsCount={dataRolesList?.total}
          isPending={isPending || isDeleting}
          rowIdGetter={(row) => row.id}
          searchDebouncingDelay={SEARCH_DEBOUNCE_DELAY_IN_SECONDS}
          shouldMask={false}
        /> */}
				<PrimeDataGrid
					columns={dataRolesList ? dataRolesList.headerColumns : []}
					rows={dataRolesList?.items}
					showIndexColumn={true}
					showChecboxColumn={true}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					isLoading={
						isPending || isDeleting
						// || isBulkDeleting
					}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						dataRolesList && dataRolesList.total ? dataRolesList.total : 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					// selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search by Year..."}
				// changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
				//   setzeroCountry(value)
				// }
				/>
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"year-field-tab-list-snackbar"}
				open={snackbarData.open}
			/>
		</>
	);
	// switch (componentState) {
	//   case ComponentState.LOADING:
	//     return (
	//       <CircularProgress
	//         size={24}
	//         data-testid="circular-progress"
	//         className={classes.loader}
	//       />
	//     );
	//   case ComponentState.ERROR:
	//     return (
	//       <div>Error loading component data</div>
	//       // <ErrorState
	//       //   testId="error-container"
	//       //   message={message}
	//       //   onClick={() => {
	//       //     clearError();
	//       //     let dispatchParams = {
	//       //       search_query: "",
	//       //       order_by: "acc_title",
	//       //       order_direction: "asc",
	//       //       page: 1,
	//       //       size: 50,
	//       //     };
	//       //     dispatch(loadAccountantListRequest(dispatchParams));
	//       //   }}
	//       // />
	//     );
	//   case ComponentState.DATA:
	//     return emptyList ? (
	//       <EmptyAccountantList />
	//     ) : (
	//       <Grid
	//         item
	//         xs={12}
	//         sm={12}
	//         md={12}
	//         lg={12}
	//         xl={12}
	//         className={classes.list}
	//       >
	//         {/* <EnhancedDialog
	//           dialogTitle="Please Confirm"
	//           key="dialog-box"
	//           testId="dialog"
	//           onCloseHandler={onCloseHandler}
	//           open={openDialog}
	//           dialogContent={
	//             <Typography variant="subtitle1">Are you sure?</Typography>
	//           }
	//           dialogAction={
	//             <Grid>
	//               <Button
	//                 autoFocus
	//                 variant="contained"
	//                 onClick={onCloseHandler}
	//                 color="default"
	//                 className={classes.button}
	//               >
	//                 Cancel
	//               </Button>
	//               <Button
	//                 autoFocus
	//                 variant="contained"
	//                 onClick={callAction}
	//                 color="primary"
	//                 className={classes.button}
	//               >
	//                 ok
	//               </Button>
	//             </Grid>
	//           }
	//         /> */}
	//         <EnhancedDataGrid
	//           columns={accountantList ? accountantList.headerColumns : []}
	//           rows={accountantList?.items}
	//           selectionEnabled={true}
	//           autoHeight={true}
	//           allowSearching={true}
	//           rowsPerPageOptions={[10, 25, 50, 100]}
	//           selectionToolbar={selectionToolbar}
	//           onRowEditClicked={onRowEditClicked}
	//           onRowDeleteClicked={onRowDeleteClicked}
	//           initialPageSize={accountantList?.size}
	//           disableColumnMenu={true}
	//           showRowActionsColumn={true}
	//           autoPageSize={true}
	//           showIndexColumn={true}
	//           testId="accountant-list-grid"
	//           sortingMode="server"
	//           filterMode="server"
	//           paginationMode="server"
	//           onRequestParamsChange={onRequestParamsChange}
	//           totalRowsCount={accountantList?.total}
	//           isPending={false}
	//           rowIdGetter={(row) => row.id}
	//           searchDebouncingDelay={2000}
	//           shouldMask={false}
	//         />
	//       </Grid>
	//     );
	//   default:
	//     return null;
	// }
};

function dispatch(arg0: any) {
	throw new Error("Function not implemented.");
}
// // export const AccountantListContent: React.FC<IAccountantList> = () => {
// //   return (<div>This Accountant List Content Page</div>);
// // }
